/*
 * @Author: zcj
 * @Date: 2025-01-15 19:46:54
 * @LastEditTime: 2025-12-12 17:28:19
 * @LastEditors: 'zcj' '2736104855@qq.com'
 * @Description: 
 * @FilePath: \h5e:\travel-app\src\service\user\index.ts
 */
import { http } from '@/utils/http'
export interface IFooItem {
  id: string
  name: string
}

// 获取用户打车券金额
export const getYcCouponAmount = (data) => {
  return http.get<IFooItem>('/wxapp/ycCoupon/getYcCouponAmount', data)
}
// 详情
export const bPlusOrderDetail = (data) => {
  return http.get<IFooItem>('/wxapp/ycCoupon/bPlusOrderDetail', data)
}
// 打车券申请退款
export const applyRefund = (data) => {
  return http.post<IFooItem>('/wxapp/ycCoupon/applyRefund', data)
}
// 用户注册信息更改
export const clientModify = (data) => {
  return http.post<IFooItem>('/wxapp/clientModify', '', data)
}
// 查用户打车券明细
export const couponOrderDetailsPage = (data) => {
  return http.get<IFooItem>('/wxapp/ycCoupon/couponOrderDetailsPage', data)
}
// 出行版本号储存
export const projectVersion = (data) => {
  return http.get<IFooItem>('/wxapp/projectVersion', data)
}
// 联系人保存
export const contactSave = (data) => {
  return http.post<IFooItem>('/wxapp/save/contacts', data)
}
// 联系人查询
export const contactQuery = (data) => {
  return http.get<IFooItem>('/wxapp/query/contacts', data)
}
// 联系人删除
export const contactDel = (data) => {
  return http.get<IFooItem>('/wxapp/del/contacts', data)
}
// 查询用户绑卡列表
export const userBindBankCardList = (data) => {
  return http.get<IFooItem>('/wjbPay/userBindBankCardList', data)
}
// 查询可绑卡银行列表
export const queryBindBankCardList = (data) => {
  return http.get<IFooItem>('/wjbPay/queryBindBankCardList', data)
}
// 获取微信分享配置
export const wxShare = (data) => {
  return http.get<IFooItem>('/unionCloud/login/wx/share', '', data)
}
// 单点登录
export const SSOParseReq = (data) => {
  return http.get<IFooItem>('/wxapp/oauth/SSOParseReq', data)
}
// 查询用户已领取优惠券
export const queryUserCoupon = (data) => {
  return http.post<IFooItem>('/conpon/v1/queryUserCoupon', data)
}
// 判断用户是否绑定微信 或者 关注公众号
export const isBindOrAttention = (data) => {
  return http.get<IFooItem>('/wechat/isBindOrAttention', data)
}
// 开启或关闭推送通知
export const openOrCloseNotice = (data) => {
  return http.get<IFooItem>('/wechat/openOrCloseNotice', data)
}
// 查询用户是否开启消息订阅
export const isOpenNotice = (data) => {
  return http.get<IFooItem>('/wechat/isOpenNotice', data)
}